import { fetchApi } from "../../config/fetchConfig";
import I18n from "../../I18n";
import { pushDialog } from "./dialogActions";
export const getTranslationTableDatasetLocaleAndEntities =
    (organizationID, datasetLocale) => (dispatch, getState) => {
        const queriesBody = {
            query: `query($o:String!,$c:String!){translation_table_datasetLocale_and_entities(organizationID:$o,datasetLocale:$c){datasetLocales{value,name}, entities{value,name}}}`,
            variables: {
                o: `${organizationID}`,
                c: `${datasetLocale}`,
            },
        };

        return fetchApi("/graphql", queriesBody, {}, { dispatch, user: getState()?.user })
            .then((res) => res.json().catch(() => ({})))
            .then((res) => {
                const data = res.data["translation_table_datasetLocale_and_entities"] || {};
                return data;
            })
            .catch((e) => {
                dispatch(
                    pushDialog("AlertDialog", I18n.translate`Request Error`, {
                        title: I18n.translate`Somethings went wrong getting translation_table_datasetLocale_and_entities`,
                    }),
                );
            });
    };

export const deleteTranslationTableAction = (id) => (dispatch, getState) => {
    const queriesBody = {
        query: `mutation($i:String!){deleteTranslationTable(translationTableId:$i)}`,
        variables: {
            i: `${id}`,
        },
    };

    return fetchApi("/graphql", queriesBody, {}, { dispatch, user: getState()?.user })
        .then((res) => res.json().catch(() => ({})))
        .then((res) => {
            const data = res.data || {};
            return data;
        })
        .catch((e) => {
            throw new Error(e.message);
        });
};

export const saveTranslationDetails =
    (translationTableBuilderId, updateObject, translationId, combination, related_entities) => (dispatch, getState) => {
        const queriesBody = {
            query: `mutation($t:String,$o:String!,$tran:String!,$c:String!,$re:String!){update_translation_builder(translationTableBuilderId:$t,updateObject:$o,translationId:$tran,combination:$c,relatedEntities:$re){
                        success
                    }}`,
            variables: {
                t: translationTableBuilderId ? translationTableBuilderId.toString() : null,
                o: updateObject,
                tran: `${translationId}`,
                c: combination,
                re: related_entities,
            },
        };

        return fetchApi("/graphql", queriesBody, {}, { dispatch, user: getState()?.user })
            .then((res) => res.json().catch(() => ({})))
            .then((res) => res?.data);
    };

export const deleteTranslationDetailsRowAction =
    (id, translationId, deleteAll = false) =>
    (dispatch, getState) => {
        const queriesBody = {
            query: `mutation($i:String!,$t:String!,$da:Boolean!){deleteTranslationBuilderRow(id:$i,translationTableId:$t,deleteAll:$da)}`,
            variables: {
                i: `${id}`,
                t: `${translationId}`,
                da: deleteAll,
            },
        };

        return fetchApi("/graphql", queriesBody, {}, { dispatch, user: getState()?.user })
            .then((res) => res.json().catch(() => ({})))
            .then((res) => {
                const data = res.data || {};
                return data;
            })
            .catch((e) => {
                throw new Error(e.message);
            });
    };

    // Returns { organizationId: number; combinations: Record<string, number>; translationTableId: number }
export const getTranslationBuilderCombinationsStats =
(organizationId, datasetLocale, translationTableId) =>
(dispatch, getState) => {
    const queriesBody = {
        query: `query($o:String!,$dl:String!, $t:String!){
            translation_builder_combinations_stats(organizationId:$o, datasetLocale:$dl, translationId:$t){
                combination
                entities
                related_entities
            }
        }`,
        variables: {
            o: `${organizationId}`,
            dl: datasetLocale,
            t: `${translationTableId}`,
        },
    };

    return fetchApi("/graphql", queriesBody, {}, { dispatch, user: getState()?.user })
        .then((res) => res.json().catch(() => ({})))
        .then((res) => res?.data?.translation_builder_combinations_stats)
        .catch((e) => {
            throw new Error(e?.message || "Error fetching combinations stats");
        });
};

export const applyRelatedEntitiesAction =
(organizationId, selectedEntities) =>
(dispatch, getState) => {
    const queriesBody = {
        query: `mutation($o:String!,$re:String!){
                    apply_related_entities_to_translations(organizationId:$o,selectedEntities:$re)
                }`,
        variables: {
            o: `${organizationId}`,
            re: `${JSON.stringify(selectedEntities)}`,
        },
    };

    return fetchApi("/graphql", queriesBody, {}, { dispatch, user: getState()?.user })
        .then((res) => res.json().catch(() => ({})))
        .then((res) => {
            const data = res.data || {};
            return data;
        })
        .catch((e) => {
            throw new Error(e.message);
        });
};
